import { components } from '@/types/api';
import { useQuery } from '@tanstack/react-query';
import FundsUsed from '@/assets/icons/funds_used.svg?react';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import { format } from 'date-fns';
import GroceryBagBenefits from '@/assets/icons/grocery_bag_benefits.png';
import { BenefitRulesModal } from './BenefitRulesModal';
import { useState } from 'react';

export function BenefitProgramActivites({
  account,
}: {
  account: components['schemas']['AccountDetailsOutput'];
}) {
  const { apiFetch } = useOpenApiClient();
  const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
  const accountActivitiesQuery = useQuery({
    queryKey: ['v1', 'accounts', account?.id, 'activities'],
    queryFn: () =>
      apiFetch.GET('/accounts/{account_id}/activities', {
        params: {
          path: { account_id: account?.id },
        },
      }),
    enabled: Boolean(account?.id),
    select: (data) => data.data?.data,
  });
  return (
    <>
      <div className="text-foreground relative flex items-center justify-between rounded-[10px] bg-white p-3 text-sm leading-normal font-semibold">
        <span>
          You have&nbsp;
          <span className="text-primary">{account.balance}</span> left
          <br />
          to spend.
        </span>
        <img
          src={GroceryBagBenefits}
          alt="Grocery Bag Benefits"
          className="mr-5 h-[73px] object-cover"
        />
        <BenefitRulesModal
          account={account}
          isOpen={isRulesModalOpen}
          setIsRulesModalOpen={setIsRulesModalOpen}
        />
      </div>
      <h3 className="text-foreground px-5 pt-5 pb-4 text-base leading-normal font-bold">
        Recent activities
      </h3>
      <div className="scrollbar-hide no-scrollbar flex flex-col gap-1 overflow-y-auto rounded-[10px] bg-white p-3">
        {accountActivitiesQuery.data?.map((activity) => (
          <div
            className="flex flex-row items-center justify-between border-b border-b-gray-200 py-1.5"
            key={activity.id}
          >
            <div className="flex flex-row items-center gap-4">
              <FundsUsed />
              <div className="flex flex-col">
                <span className="text-base">
                  <strong>Funds Used</strong>
                </span>
                <span className="text-xs opacity-70">
                  {format(new Date(activity.transaction_date), 'EEEE')} | {activity.merchant_name}
                </span>
              </div>
            </div>
            <strong>${activity.amount}</strong>
          </div>
        ))}
      </div>
    </>
  );
}
